<script setup lang="ts">
import { type ScadenzaElettorale } from "@gasparigit/omnia-sdk";

defineProps<{
  content: ScadenzaElettorale;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #info></template>
    <template #preview>
      <div class="font-mono flex flex-col text-tertiary items-start justify-center font-semibold text-base me-2 mb-2 md:mb-0" v-if="content.date">
        <span class="text-3xl">{{ content.date.getDate() }}</span>
        <span>{{ content.date.toLocaleString("default", { month: "long" }) }}</span>
        <span>{{ content.date.getFullYear() }}</span>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
